/**
 * Resolve the background style for a route path from the server-hydrated page map.
 *
 * An exact path wins. Otherwise the nearest ancestor path does, which is what makes the
 * detail routes work without repeating the shell mapping the server already owns:
 * /calendar/<event-slug> has no page of its own and takes the calendar's style, while
 * /calendar/academic-calendar keeps its own. Matching only on segment boundaries stops
 * e.g. /calendar-archive from being treated as a child of /calendar.
 *
 * @param {Record<string, string>} pageThemes Path => background style.
 * @param {string} path Route path.
 * @returns {string} The style, or '' when nothing matches.
 */
export function pageThemeForPath(pageThemes, path) {
  if (!pageThemes || typeof path !== 'string' || path === '') {
    return '';
  }

  const normalisedPath = normalisePath(path);

  if (pageThemes[normalisedPath]) {
    return pageThemes[normalisedPath];
  }

  return (
    Object.keys(pageThemes)
      .filter(pagePath => pagePath !== '/' && normalisedPath.startsWith(`${pagePath}/`))
      .sort((a, b) => b.length - a.length)
      .map(pagePath => pageThemes[pagePath])
      .find(Boolean) || ''
  );
}

function normalisePath(path) {
  const withoutTrailingSlash = path.replace(/\/+$/, '');

  return withoutTrailingSlash === '' ? '/' : withoutTrailingSlash;
}
